import { render } from "./TestCasesPagination.vue?vue&type=template&id=2bb1479c&scoped=true"
import script from "./TestCasesPagination.vue?vue&type=script&lang=js"
export * from "./TestCasesPagination.vue?vue&type=script&lang=js"

import "./TestCasesPagination.vue?vue&type=style&index=0&id=2bb1479c&lang=scss&scoped=true"

import exportComponent from "/builds/initiative/engineering/man_core/man-intelligence-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bb1479c"]])

export default __exports__